import React from 'react'
import { Button, Modal, Header, Label } from 'semantic-ui-react'

export default ({ visible, onClose, data }) => (
  <Modal open={visible} size="small" style={{ marginTop: 0 }}>
    <Header content={data.merchant_name} />
    <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="hide-scrollbar">
      {
        Object.values(data.codes).map(({ code, redeemed }) => (
          <Label color={redeemed && 'green'} style={{ marginTop: 3 }}>{code}</Label>
        ))
      }
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose} content="Close" />
    </Modal.Actions>
  </Modal>
)



// WEBPACK FOOTER //
// ./src/containers/rewards/MerchandiseCodes/components/Detail.js